import { FaUserCircle } from 'react-icons/fa';
import { ProfileViewMain } from '../Components/ProfileViewMain';

export const ProfileModule = () => [{
    views: 'PRIVATE', path: '/dashboard/perfil', component: <ProfileViewMain />,
    roles: null, permissions: null, label: 'Perfil', icon: <FaUserCircle />,
    displayInHeader: false, displayInFooter: false, displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
